"use client";
import { useEffect, useState } from "react";
import classes from "./TrapeziumDivider.module.scss";

type Props = {
  customClassName?: string;
};

const TrapeziumDivider = ({ customClassName }: Props) => {
  const circles = Array.from({ length: 10 }, (_, index) => index + 1);

  const [randomCircles, setRandomCircles] = useState<any[]>([]);

  useEffect(() => {
    const randomCircleCount = Math.floor(Math.random() * 10) + 5;

    const newRandomCircles = Array.from({ length: randomCircleCount }, () => {
      const size = Math.floor(Math.random() * 10) + 1;
      const top = Math.floor(Math.random() * 10) + 10;
      const left = Math.floor(Math.random() * 95);
      return { size, top, left };
    });

    setRandomCircles(newRandomCircles);
  }, []);

  return (
    <div className={`${classes["trapezium-divider"]} ${customClassName}`}>
      {circles.map((circleNumber) => (
        <div
          key={circleNumber}
          className={classes[`circle${circleNumber}`]}
        ></div>
      ))}

      {randomCircles.map((circle, index) => (
        <div
          key={index}
          className={classes["random-circle"]}
          style={{
            width: `${circle.size}px`,
            height: `${circle.size}px`,
            top: `${circle.top}%`,
            left: `${circle.left}%`,
          }}
        ></div>
      ))}
    </div>
  );
};

export default TrapeziumDivider;
